// extracted by mini-css-extract-plugin
export default {"form":"FeedbackDialog-module_form_aa1e4691","select":"FeedbackDialog-module_select_efc17951","option":"FeedbackDialog-module_option_e8ef0873"};